// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-button-sm[data-v-0adcabb7]{height:35px;width:35px;font-size:.875rem;padding:.7rem}.p-component[data-v-0adcabb7]:disabled,.p-disabled[data-v-0adcabb7]{opacity:.8}.p-dropdown[data-v-0adcabb7]{min-width:200px}.vue-json-pretty[data-v-0adcabb7]{font-family:monospace;background:#282c34;color:#fff;padding:15px;border-radius:8px;overflow-x:auto}", ""]);
// Exports
module.exports = exports;
